import React from 'react'

export const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.linkedin.com/in/rajeev-kumar-336051222/" className="home__social-icon" target="_blank">
        <i class="uil uil-linkedin-alt"></i>
        </a>

        <a href="https://github.com/rajeev35" className="home__social-icon" target="_blank">
        <i class="uil uil-github-alt"></i>
        </a>

        <a href="https://www.instagram.com/krajeev.me/" className="home__social-icon" target="_blank">
        <i class="uil uil-instagram"></i>
        </a>
    </div>
  );
};

export default Social;
